export const PUBNUB_PUBLISH_KEY = import.meta.env.VITE_PUBNUB_PUBLISH_KEY;
export const PUBNUB_SUBSCRIBE_KEY = import.meta.env.VITE_PUBNUB_SUBSCRIBE_KEY;
export const PUBNUB_PRESENCE_TIMEOUT = 30;
export const PUBNUB_HEARTBEAT_INTERVAL = 14;

export const MessageStatus = {
  sending: 'sending',
  sent: 'sent',
  failed: 'failed',
} as const;

export type MessageStatus = (typeof MessageStatus)[keyof typeof MessageStatus];

export enum ChannelType {
  DIRECT = 'direct',
}

export const SUPPORTER_ID = import.meta.env.VITE_SUPPORTER_ID;

export const VOICE_MESSAGE_NAME_PREFIX = 'avanta-voice';

export const CHAT_BUTTON_CLASSNAME = 'hover:bg-transparent hover:[&>svg]:stroke-[2.5px]';

export const CHAT_BUTTON_INPUT_CLASSNAME = `${CHAT_BUTTON_CLASSNAME} hover:text-teal-600 hover:[&>svg]:stroke-teal-600`;

export const CHAT_BUTTON_ACTIVE_CLASSNAME = '[&>svg]:stroke-[2.5px]';

export const ALLOWED_FILE_TYPES: { [extension: string]: string } = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  webp: 'image/webp',
  gif: 'image/gif',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  txt: 'text/plain',
  rtf: 'application/rtf',
  mp4: 'video/mp4',
  webm: 'video/webm',
  mp3: 'audio/mpeg',
  ogg: 'audio/ogg',
};

export enum MessageFileTypeEnum {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  FILE = 'file',
}
